var React = require('react');

function Info (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("g",{"key":0},[React.createElement("path",{"fill":"none","stroke":"#000000","strokeLinejoin":"round","d":"M32.04,37.515l1.572,1.572c-2.4,4.309-7.411,4.037-7.411,4.037\r\n\t\t\tc-8.447,0-7.826-5.65-7.826-5.65l0.994-12.05c0.249-3.293-2.981-3.23-2.981-3.23v-1.987h10.931l-0.992,17.143\r\n\t\t\tc0,0,0.082,2.156,2.566,2.072C31.376,39.337,32.04,37.515,32.04,37.515z","key":0}),React.createElement("circle",{"fill":"none","stroke":"#000000","strokeLinejoin":"round","cx":"23.014","cy":"11.51","r":"4.637","key":1})]),React.createElement("circle",{"fill":"none","stroke":"#000000","strokeLinejoin":"round","cx":"25","cy":"25","r":"23.667","key":1})]));
}

Info.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"50px","height":"50px","viewBox":"0 0 50 50","enableBackground":"new 0 0 50 50","xmlSpace":"preserve"};

module.exports = Info;

Info.default = Info;
